import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';

import Badge from 'src/componentes/Badge';

import Button from 'src/componentes/button';

const Stepper = ({
  initialStepIndex = 1,
  steps,
  children,
  getSetActiveStep,
  containerHeight = 'auto',
  backButtonText = 'label.voltar',
  nextButtonText = 'label.proximo',
  nextCallback = () => {},
  backCallback = () => {},
  confirmNextStep = false,
  hideButtons = false,
  blockButtons = false,
  blockNextButton = false,
  blockBackButton = false,
  canClickOnStep = false,
  showProgressStates = false,
  activeStepIndex: activeStepIndexProp,
  onStepChange,
}) => {
  const intl = useIntl();

  const isControlled = activeStepIndexProp != null;
  const [internalIndex, setInternalIndex] = useState(initialStepIndex);
  const activeStepIndex = isControlled ? activeStepIndexProp : internalIndex;
  const actualStep = activeStepIndex + 1;

  const setActiveStepIndex = (index) => {
    if (!isControlled) setInternalIndex(index);
    if (typeof onStepChange === 'function') onStepChange(index);
  };

  useEffect(() => {
    if (typeof getSetActiveStep === 'function') {
      getSetActiveStep(setActiveStepIndex);
    }
  }, [getSetActiveStep]);

  const handleStepClick = (index) => {
    const newStep = index + 1;

    if (newStep > actualStep) {
      nextCallback(newStep, setActiveStepIndex, index, true);

      if (!confirmNextStep) setActiveStepIndex(index);
    } else {
      backCallback(newStep);

      setActiveStepIndex(index);
    }
  };

  const renderSteps = () => {
    return (
      <div className="d-flex flex-wrap">
        {steps?.map((step, index) => {
          const isActive = index === activeStepIndex;
          const isCompleted = showProgressStates && index < activeStepIndex;
          const isUpcoming = showProgressStates && index > activeStepIndex;
          const needsAttention = showProgressStates && step.needsAttention;

          let circleClass = isActive ? 'bg-primary' : 'bg-gray';
          let circleStyle = { height: 25, width: 25 };
          let circleContent = index + 1;

          if (showProgressStates) {
            if (needsAttention) {
              circleClass = 'bg-danger';
              circleContent = '!';
            } else if (isActive) {
              circleClass = 'bg-primary';
            } else if (isCompleted) {
              circleClass = 'bg-secondary';
            } else {
              circleClass = 'bg-gray';
            }
          }

          const titleMuted = showProgressStates
            ? isUpcoming && !needsAttention
            : !isActive;

          return (
            <div
              key={index}
              className={`d-flex align-items-center my-2 ${
                index + 1 < steps.length ? 'mr-5' : ''
              }`}
              onClick={() => {
                if (!isActive && canClickOnStep) {
                  handleStepClick(index);
                }
              }}
              style={{
                cursor: 'pointer',
                opacity: isUpcoming && !needsAttention ? 0.5 : 1,
              }}
            >
              <div
                style={circleStyle}
                className={`d-flex justify-content-center align-items-center rounded-circle font-weight-bolder text-white mr-2 
                  ${circleClass}`}
              >
                {circleContent}
              </div>
              <div>
                <div
                  className={`font-weight-bolder ${
                    titleMuted ? 'text-muted' : ''
                  }`}
                >
                  {step.titulo}
                </div>
                <div className="text-muted text-sm">{step.descricao}</div>
              </div>
              {step.showBadge && (
                <Badge
                  style={{
                    background: '#feac3126',
                    color: 'red',
                    fontSize: '11px',
                    marginLeft: '8px',
                    borderStyle: 'solid',
                    borderColor: '#feac315c',
                    borderWidth: '2px',
                  }}
                >
                  {step.badgeText}
                </Badge>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const handleNext = () => {
    const newStep = actualStep + 1;
    nextCallback(newStep, setActiveStepIndex, activeStepIndex + 1);

    if (!confirmNextStep) setActiveStepIndex(activeStepIndex + 1);
  };

  const handleBack = () => {
    const newStep = actualStep - 1;
    backCallback(newStep);

    setActiveStepIndex(activeStepIndex - 1);
  };

  const renderFooter = () => {
    return (
      <div className="actions clearfix">
        {activeStepIndex === 0 ? (
          ''
        ) : (
          <Button
            outline
            disabled={blockButtons || blockBackButton}
            className="pull-left"
            onClick={() => handleBack()}
            id="prev-button"
          >
            {intl.formatMessage({ id: backButtonText })}
          </Button>
        )}
        {actualStep === steps.length ? (
          ''
        ) : (
          <Button
            disabled={blockButtons || blockNextButton}
            className="pull-right"
            onClick={() => handleNext()}
            id="next-button"
          >
            {intl.formatMessage({ id: nextButtonText })}
          </Button>
        )}
      </div>
    );
  };

  return (
    <div>
      {renderSteps()}
      <hr></hr>
      <div className="overflow-hidden">
        <div style={{ height: containerHeight, maxHeight: containerHeight }}>
          {children}
        </div>
      </div>
      <hr></hr>
      {!hideButtons && renderFooter()}
    </div>
  );
};

export default Stepper;
